import wixData from 'wix-data';

// Filter dataset by choice and save to session storage
export function filterPageByChoice(dataSet, filteredField, filterBy) {
    let productFilter = wixData.filter();
    productFilter = productFilter.contains(filteredField, filterBy).and(productFilter.eq("status", "Active"));
    dataSet.setFilter(productFilter);
}


// Filter dataset selected field by Range
export function filterProducts(dataSet, filteredField, filterStartIndex,filterEndIndex,) {
    let productFilter = wixData.filter();
    productFilter = productFilter.between(filteredField,filterStartIndex, filterEndIndex);
    dataSet.setFilter(productFilter);
}


// Sorts a selected dataset and a selected field ascending or descendding
export function sortProducts(dataSet, sortType, sortedFiled) 
{    
    if (sortType == 'ascending') 
        dataSet.setSort( wixData.sort().ascending(sortedFiled));

    else dataSet.setSort( wixData.sort().descending(sortedFiled));
}


export function filterActiveSpaProductsByCategory(dataSet, filteredCategoryField, filterValue) {
    let productFilter = wixData.filter();
    const filterByActive = wixData.filter().contains("status","Active");
    productFilter = productFilter.eq(filteredCategoryField,filterValue);
    dataSet.setFilter(productFilter.and(filterByActive));
}


export function updateClicksOnObject(event) 
{
    let $repeaterItem = $w.at(event.context);
    let clickCounter;       // Variable used for storing the amount of clicks for the selected repeater item.
    let toUpdate;           // Variable used for storing all the repeater item's data, including the updated counter. 
   
    clickCounter = Number($repeaterItem('#clickCounterButton').label);   

    // Find the entry in the DB with the same _id as the selected repeater item.
    wixData.query("spaProducts").eq("_id", $repeaterItem('#itemIDButton').label).find().then( (results) => 
    {
      if(results.items.length > 0) 
      {
        let datasetItem = results.items[0];
        datasetItem.clickCounter = clickCounter; 
        
        wixData.get("spaProducts",datasetItem);
        toUpdate = datasetItem;
        toUpdate.ClickCounter++;
        wixData.update("spaProducts", toUpdate);
      } 
      else 
      {
        console.log("No matching items found.");
      }
    } )
    .catch( (err) => 
    {
      let errorMsg = err;
    } );

} 